import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { MenuItem } from 'primeng/api';

import { MenuItemComponent } from '../menu-item/menu-item.component';
@Component({
  selector: '[app-menu]',
  templateUrl: './menu.component.html',
  imports: [MenuItemComponent, RouterModule],
})
export class MenuComponent {
  protected model: MenuItem[] = [];

  constructor(private readonly router: ActivatedRoute) {
    this.model = this.router.snapshot.data.menu;
  }
}
